import { ReactNode, useEffect } from 'react'

import FirstBigImage from './first-big-image/index'
import FirstTwoImages from './first-two-images/index'
import ImagesGrid from './imagesGrid/index'
import VideosFull from './fullHeightVideos/index'
import HorizontalImagesShowcase from './horizontalImagesShowcase/index'
import { PortfolioComponent } from '@/data/portfolio/type/client-index'
import PresentationSlide from './presentationSlide/index'
import ImageTopDescriptionBottom from './imageTopDescriptionBottom'
import FullHeightVideos from './fullHeightVideos/index'
import SingleImage from './singleImage'

type Component = {
  name: PortfolioComponent
  class: string
  component: React.FC | ReactNode | JSX.Element
}

const allComponents: Component[] = [
  {
    name: PortfolioComponent.presentationSlide,
    class: 'w-full',
    component: PresentationSlide
  },
  {
    name: PortfolioComponent.horizontalImagesShowcase,
    class: 'min-w-full',
    component: HorizontalImagesShowcase
  },
  {
    name: PortfolioComponent.imageGrid,
    class: '',
    component: ImagesGrid
  },
  {
    name: PortfolioComponent.imageTopDescriptionBottom,
    class: '',
    component: ImageTopDescriptionBottom
  },
  {
    name: PortfolioComponent.fullHeightVideos,
    class: '',
    component: FullHeightVideos
  },
  { name: PortfolioComponent.singleImage, class: '', component: SingleImage }
  //   name: 'full-height-image',
  //   class: '',
  //   component: FullHeightImage
  // }
  // {
  //   name: 'first-big-image',
  //   class: 'w-full',
  //   component: FirstBigImage
  // },
  // {
  //   name: 'first-two-images',
  //   class: 'w-full',
  //   component: FirstTwoImages
  // },
  // {
  //   name: 'images-grid',
  //   class: '',
  //   component: ImagesGrid
  // },
  // {
  //   name: 'full-height-videos',
  //   class: '',
  //   component: VideosFull
  // },
  // {
  //   name: 'horizontal-images-showcase',
  //   class: 'min-w-full',
  //   component: HorizontalImagesShowcase
  // },
  // {
  //   name: 'full-height-image',
  //   class: '',
  //   component: FullHeightImage
  // }
]

export default allComponents

export const fallback = ({ componentName }) => {
  useEffect(() => {
    console.error('The component with the name ' + componentName + ' does not exists')
  }, [])

  return <div></div>
}
